/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Audio_Too_LongInputs */



/**
* | output |
* | --- |
* | "This audio file is too long to transcribe." |
*
* @param {Embedding_Error_Audio_Too_LongInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_audio_too_long = /** @type {((inputs?: Embedding_Error_Audio_Too_LongInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Audio_Too_LongInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Audiodatei ist zu lang, um transkribiert zu werden.")
	return /** @type {LocalizedString} */ ("This audio file is too long to transcribe.")
});